import { DEFAULT_TASK_OBJECT_NAMING } from "../../types";
import { transformTaskCustomFieldDtoToTaskCustomFieldModel } from "../TaskCustomField";
import { TaskBoardDto } from "./TaskBoardDto";
import { TaskBoardModel } from "./TaskBoardModel";

// TaskBoardDto -> TaskBoardModel
export const transformTaskBoardDtoToModel = (
  dto: TaskBoardDto
): TaskBoardModel => ({
  id: dto.id,
  name: dto.name,
  color: dto.color,
  description: dto.desc || "",
  users: dto.users,
  prefix: dto.prefix || "",
  customStatuses: dto.custom_statuses,
  customFields: dto.custom_fields.map(
    transformTaskCustomFieldDtoToTaskCustomFieldModel
  ),
  fieldsSettings: dto.settings.fields || {},
  taskObjectNaming: {
    singular:
      dto.settings.item_name_singular || DEFAULT_TASK_OBJECT_NAMING.singular,
    plural: dto.settings.item_name_plural || DEFAULT_TASK_OBJECT_NAMING.plural,
  },
  includeOrderDetails: dto.settings.include_order_details || false,
  includeBillingFiles: dto.settings.include_invoice_docs || false,
});

// Partial<TaskBoardDto> -> Partial<TaskBoardModel>
// Used to update cached board data without overriding the existing data
export const transformPartialTaskBoardDtoToPartialTaskBoardModel = (
  dto: Partial<TaskBoardDto>
): Partial<TaskBoardModel> => ({
  id: dto.id,
  name: dto.name,
  color: dto.color,
  description: dto.desc ?? undefined,
  prefix: typeof dto.prefix === "undefined" ? undefined : dto.prefix || "",
  users: dto.users,
  customStatuses: dto.custom_statuses,
  customFields: dto.custom_fields?.map(
    transformTaskCustomFieldDtoToTaskCustomFieldModel
  ),
  fieldsSettings: dto.settings?.fields || {},
  taskObjectNaming:
    dto.settings?.item_name_singular && dto.settings?.item_name_plural
      ? {
          singular: dto.settings?.item_name_singular,
          plural: dto.settings?.item_name_plural,
        }
      : undefined,
  includeOrderDetails: dto.settings?.include_order_details ?? undefined,
  includeBillingFiles: dto.settings?.include_invoice_docs ?? undefined,
});
